var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityView } from './entity-view';
var cls = classNames('entity-view-aside-content');
export var EntityViewAsideDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityViewAside',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityViewAside = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, EntityViewAsideDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var asideViews = (_a = entity === null || entity === void 0 ? void 0 : entity.entityViews) === null || _a === void 0 ? void 0 : _a.filter(function (view) {
    var _a;
    return ((_a = view.type) === null || _a === void 0 ? void 0 : _a.slug) === 'aside';
  });
  if (!asideViews) {
    return null;
  }
  if (!asideViews.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, asideViews.map(function (view, i) {
    return React.createElement(EntityView, {
      view: view.hash,
      entity: entity,
      key: view.id
    });
  }), children);
};
EntityViewAside.cls = cls;
var templateObject_1, templateObject_2;